import { useState } from "react";
import { toast } from "sonner";
import { Zap, Settings2, Plus, Trash2, Check, X, MapPin } from "lucide-react";
import { api } from "@/lib/api";

export default function WaQuickReplies({ items = [], onPick, onSaved }) {
    const [edit, setEdit] = useState(null);

    const save = async () => {
        const clean = edit.filter((i) => i.title.trim() && (i.kind === "location" || i.text.trim()));
        try {
            const { data } = await api.put("/admin/whatsapp/quick-replies", { items: clean });
            onSaved(data);
            setEdit(null);
            toast.success("Përgjigjet e shpejta u ruajtën");
        } catch (e) {
            toast.error("Ruajtja dështoi");
        }
    };
    const setAt = (i, patch) => setEdit((l) => l.map((x, j) => (j === i ? { ...x, ...patch } : x)));

    if (edit) {
        return (
            <div className="px-3 pt-3 border-t border-slate-200 space-y-2" data-testid="wa-qr-editor">
                <div className="max-h-56 overflow-y-auto space-y-2 pr-1">
                    {edit.map((q, i) => (
                        <div key={i} className="grid grid-cols-[120px_1fr_auto] gap-2 items-start" data-testid={`wa-quick-edit-${i}`}>
                            <div className="space-y-1">
                                <input value={q.title} onChange={(e) => setAt(i, { title: e.target.value })} placeholder="Titulli" maxLength={40} className="input-field !py-1.5 text-xs font-bold" />
                                <select value={q.kind || "text"} onChange={(e) => setAt(i, { kind: e.target.value })} className="input-field !py-1 text-[11px]" data-testid={`wa-quick-kind-${i}`}>
                                    <option value="text">Tekst</option>
                                    <option value="location">📍 Lokacion</option>
                                </select>
                            </div>
                            {q.kind === "location" ? (
                                <div className="text-[11px] text-slate-500 py-2">Dërgon pinin e lokacionit në hartë (nga Cilësimet → Lokacioni).</div>
                            ) : (
                                <textarea rows="2" value={q.text} onChange={(e) => setAt(i, { text: e.target.value })} placeholder="Mesazhi" className="input-field !py-1.5 text-xs resize-none" />
                            )}
                            <button type="button" onClick={() => setEdit((l) => l.filter((_, j) => j !== i))} className="p-1.5 text-red-600"><Trash2 className="w-4 h-4" /></button>
                        </div>
                    ))}
                </div>
                <div className="flex justify-between gap-2">
                    <button type="button" onClick={() => setEdit((l) => [...l, { title: "", text: "", kind: "text" }])} className="btn-outline !py-1.5 text-xs" data-testid="wa-quick-add"><Plus className="w-3.5 h-3.5" /> Shto</button>
                    <div className="flex gap-2">
                        <button type="button" onClick={() => setEdit(null)} className="btn-outline !py-1.5 text-xs"><X className="w-3.5 h-3.5" /> Anulo</button>
                        <button type="button" onClick={save} className="btn-primary !py-1.5 text-xs" data-testid="wa-quick-save"><Check className="w-3.5 h-3.5" /> Ruaj</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="px-3 pt-2 border-t border-slate-200 flex items-center gap-2" data-testid="wa-quick-replies">
            <Zap className="w-4 h-4 text-amber-500 shrink-0" />
            <div className="flex-1 flex gap-1.5 overflow-x-auto py-1 no-scrollbar">
                {items.map((q, i) => (
                    <button
                        key={i}
                        type="button"
                        onClick={() => onPick(q)}
                        title={q.kind === "location" ? "Dërgo lokacionin" : q.text}
                        className="shrink-0 inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full border border-[#25D366]/40 text-[#128C7E] bg-[#25D366]/10 hover:bg-[#25D366]/20 transition-colors"
                        data-testid={`wa-quick-${i}`}
                    >
                        {q.kind === "location" && <MapPin className="w-3.5 h-3.5" />}{q.title}
                    </button>
                ))}
                {items.length === 0 && <span className="text-xs text-slate-500">Asnjë përgjigje e shpejtë</span>}
            </div>
            <button type="button" onClick={() => setEdit(items.map((x) => ({ ...x })))} className="p-1.5 text-slate-500 hover:text-[hsl(var(--primary))] shrink-0" title="Menaxho" data-testid="wa-quick-manage">
                <Settings2 className="w-4 h-4" />
            </button>
        </div>
    );
}
